import React from 'react'
import numeral from 'numeral'

import { useLocation, useHistory } from 'react-router-dom'

import { addQuerystring, addToQuerystring } from '../../../utils/querystring'

import withFetch from '../../../infrastructure/withFetch'
import KeyMetricsWidget from '../KeyMetricsWidget'
import Subtitle from '../../../components/Subtitle'

import SalesChart from './components/SalesChart'

const MODES = {
    CUMULATIVE: {
        value: 1,
        label: 'Cumulative',
    },
    NON_CUMULATIVE: {
        value: 0,
        label: 'Incremental',
    },
}

const Page = ({ status, data, retry, palette, queryParams: { mode } }) => {
    const location = useLocation()
    const history = useHistory()

    const events = data.events || []
    const sales = data.sales || []
    const columnSize = events.length === 0 ? 12 : 12 / events.length

    const modeToggle = sales.length > 0 && (
        <div className="btn-group">
            {Object.keys(MODES).map(key => (
                <button
                    key={MODES[key].value}
                    className={`btn btn-xs ${
                        MODES[key].value === mode ? 'btn-primary' : 'btn-white'
                    }`}
                    type="button"
                    onClick={() => setMode(MODES[key].value)}
                >
                    {MODES[key].label}
                </button>
            ))}
        </div>
    )

    const tools = <>{modeToggle}</>

    const setMode = mode => {
        history.push(
            addToQuerystring(location, {
                mode,
            }),
        )
    }

    const isMoreThanOneEventInTheFuture =
        events.filter(event => event.daysTillEventAsAPositiveNumber > 0)
            .length > 1

    return (
        <>
            <Subtitle title="Sales" tools={tools} />
            <KeyMetricsWidget data={data} status={status} retry={retry}>
                <div className="key-metrics">
                    <div className="row m-n">
                        {events.map((e, index) => {
                            const isThisEventInTheFuture =
                                e.daysTillEventAsAPositiveNumber > 0

                            const label =
                                e.daysTillEventAsAPositiveNumber === 1
                                    ? 'day'
                                    : 'days'

                            return (
                                <div
                                    className={`col-sm-${columnSize} p-xs`}
                                    key={e.eventId}
                                    style={{
                                        borderTop: `4px solid ${palette[index]}`,
                                        fontWeight: '600',
                                    }}
                                >
                                    <div className="key-title">
                                        <div>{e.eventName}</div>
                                        <div>{e.eventDateDescription}</div>
                                        <div>{e.venueName}</div>
                                    </div>
                                    <div className="key-value">
                                        <span>
                                            {numeral(e.totalSales).format(
                                                '0,0',
                                            )}
                                        </span>
                                    </div>
                                    {isMoreThanOneEventInTheFuture &&
                                        isThisEventInTheFuture && (
                                            <div>
                                                {
                                                    e.daysTillEventAsAPositiveNumber
                                                }{' '}
                                                {label} until event
                                            </div>
                                        )}
                                </div>
                            )
                        })}
                    </div>
                    <div
                        className="row m-n key-metric-chart disable-click-md"
                        style={{
                            userSelect: 'none',
                            paddingBottom: 30,
                            paddingTop: 30,
                            cursor: 'default',
                        }}
                    >
                        <SalesChart
                            events={events}
                            sales={sales}
                            palette={palette}
                            isMoreThanOneEventInTheFuture={
                                isMoreThanOneEventInTheFuture
                            }
                        />
                    </div>
                </div>
            </KeyMetricsWidget>
        </>
    )
}

const Fetch = withFetch(
    ({ queryParams }) => addQuerystring('/api/compare/sales', queryParams),
    fetchProps => <Page {...fetchProps} />,
)

export default props => <Fetch {...props} />
